import {
  Flex,
  useDisclosure,
  Box,
  position,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useState } from "react";

const Footer = () => {
  const { colorMode } = useColorMode();
  return (
    <Box
      w={"100%"}
      minHeight={"40px"}
      display={"inline-flex"}
      alignItems={"center"}
      px={"8px"}
      py={"2px"}
      textAlign={"right"}
      float={"right"}
      justifyContent={"flex-end"}
      fontSize={"10px"}
      borderTop={"3px solid"}
      borderColor={colorMode === "light" ? "gray.100" : "gray.700"}
      color={colorMode === "dark" ? "gray.500" : "gray.400"}
    >
      created with code and lot of coffe &copy; 2025
    </Box>
  );
};

export default Footer;
